<template>
  <v-container class="py-8">
    <div class="">
      <!-- <h1 class="text-2xl text-purple">
        Join theLIFEBOARD and start the change!
      </h1> -->
      <!-- <WhySection /> -->
    </div>
    <div class=" py-12">
      <h2 class="text-center title-xl text-pink mb-4">
        {{ `Thanks for using theLIFEBOARD ${userDetails.name} 🙌` }}
      </h2>
      <p class="title text-center">
        We hope you are making the most out of it and that it has helped you
        start a change in your life. Select one of the plans below to continue:
      </p>

      <!-- <v-container> -->
      <v-row class="mt-8" justify="center">
        <v-col
          cols="12"
          sm="6"
          md="4"
          xl="3"
          class="text-center"
          v-for="prod in products"
          :key="prod.id"
        >
          <v-card
            class="px-4 py-4 rounded-lg"
            :class="
              prod.primary
                ? 'border-purple grey--text text--darken-2'
                : 'no-shadow grey--text text--darken-1'
            "
            :elevation="prod.elevation"
          >
            <v-card-title class="title-xl d-flex justify-space-around">
              <p>
                <span>{{ prod.name }}</span>
                <span class="text-purple">&nbsp;${{ prod.price }}</span>
              </p>
              <p class="caption">Lock this price as we add more features.</p>
            </v-card-title>
            <v-card-subtitle>
              <div
                class="text-center text-pink subtitle-1"
                :class="prod.primary ? 'font-weight-bold' : ''"
                v-html="prod.message"
              ></div>
            </v-card-subtitle>

            <v-card-actions class="text-center flex-wrap">
              <v-btn
                block
                :outlined="prod.primary ? false : true"
                :loading="isLoading"
                color="primary"
                :large="prod.primary ? true : false"
                :class="prod.primary ? '' : 'text-none'"
                @click="subscribe(prod.id)"
                >{{ `${prod.name} billing` }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <ReasonsSubscription />
    <FAQSubscriptions />
  </v-container>
</template>

<script>
import {mapGetters} from 'vuex'
import FAQSubscriptions from '@/components/common/FAQSubscriptions'
import ReasonsSubscription from '@/components/common/ReasonsSubscription'
import NetlifyService from '@/services/NetlifyService'

export default {
  components: {
    // WhySection,
    ReasonsSubscription,
    FAQSubscriptions,
  },
  data() {
    return {
      isLoading: false,
      ReasonsSubscriptionshowAlert: false,
      merchantId: process.env.VUE_APP_VENDOR_ID,
      products: [
        {
          name: 'Monthly',
          id: process.env.VUE_APP_MONTHLY_PLAN_ID,
          price: 4.99,
          message: `If you just want to give it a try 😉`,
          elevation: 2,
        },
        {
          name: 'Quarterly',
          id: process.env.VUE_APP_QUARTERLY_PLAN_ID,
          price: 12.99,
          primary: true,
          message: `You're committed to star the change! <br> The best seller with 15% discount 🤙`,
          elevation: 20,
        },
        {
          name: 'Yearly',
          id: process.env.VUE_APP_YEARLY_PLAN_ID,
          price: 49.99,
          primary: true,
          message: `Let's do it! This year you're unstoppable! <br> Get two months free 🤑`,
          elevation: 7,
        },
      ],
    }
  },
  computed: {
    ...mapGetters(['userDetails', 'isLoggedIn']),
  },
  created() {
    // var router = this.$router
    // load Paddle library
    this.$loadScript('https://cdn.paddle.com/paddle/paddle.js')
      .then(() => {
        // Script is loaded, do something
        if (process.env.PADDLE_TEST) {
          Paddle.Environment.set('sandbox')
          console.log('Paddle test env')
        }
        Paddle.Setup({
          vendor: process.env.VUE_APP_VENDOR_ID * 1,
        })
      })
      .catch(() => {
        // Failed to fetch script
      })
  },
  methods: {
    subscribe(productId) {
      if (!this.isLoggedIn) {
        return this.$router.push({name: 'signup'})
      }
      var router = this.$router
      var _this = this

      console.log('subscribing..')
      this.isLoading = true
      Paddle.Checkout.open({
        product: productId,
        email: this.userDetails.email,
        allowQuantity: false,
        // using successCallback removes the success overlay
        successCallback: function(data) {
          var checkoutId = data.checkout.id

          NetlifyService.subscribeUser({
            name: _this.userDetails.name,
            email: _this.userDetails.email,
            tags: ['on-subscription'],
          })

          Paddle.Order.details(checkoutId, function(data) {
            // Order data, downloads, receipts etc... available within 'data' variable.
            console.log('sub data: ', data)
            _this.isLoading = false
            router.push({
              name: 'subscription-result',
            })
          })
        },
        closeCallback: function(data) {
          console.log(data)
          _this.isLoading = false
        },
      })
    },
  },
}
</script>

<style></style>
